import FieldStoryPoints from "../../../generic/story-points/story-points";
import FieldConfig from "../../../proto/field-config";


export default class FieldTaskStoryPoints extends FieldStoryPoints {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel  = "Story points";
        this.label      = "Story points";
    }
}